import React from 'react';
import PropTypes from 'prop-types';

import { Link } from '@zola/zola-ui';

import RenderNewTableFields from './RenderNewTableFields';


class NewTableFields extends React.Component {
  componentDidMount() {
    const { fields } = this.props;
    fields.removeAll();
    fields.push({ num_tables: null, num_seats: null });
  }

  render() {
    const { fields, id, label, numTables, totalNumSeats } = this.props;

    return (
      <div style={{ position: 'relative' }}>
        <label htmlFor={id}>{label}</label>
        <div id={id}>
          {fields.map((newTable, index, fieldsRef) => (
            <RenderNewTableFields
              key={index}
              newTable={newTable}
              fieldIndex={index}
              fields={fieldsRef}
            />
          ))}
        </div>
        {numTables > 100 && <p className="table-warning">You&apos;ve exceeded the max limit of 100 tables</p>}
        {totalNumSeats > 750 && <p className="table-warning">You&apos;ve exceeded the max limit of 750 seats</p>}
        <Link role="button" className="text-primary" onClick={() => fields.push({ num_tables: null, num_seats: null })}>+ Add another set of tables</Link>
      </div>
    );
  }
}

NewTableFields.propTypes = {
  fields: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.string,
  numTables: PropTypes.number,
  totalNumSeats: PropTypes.number,
};

export default NewTableFields;


// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/util/NewTableFields.jsx